/**
 * Which files are offered to be opened in a new tab rather than only downloaded.
 *
 * <p>This decides only whether to offer. The server makes the real decision from the file's own
 * bytes, and sends anything that is not genuinely one of these back as a download — so a file
 * wrongly offered here is merely downloaded, never opened. The list matches the server's: PDF and
 * the raster images. SVG is absent on purpose; it is an image that can carry script.
 */
const VIEWABLE_TYPES = new Set(["application/pdf", "image/png", "image/jpeg"]);
const VIEWABLE_EXTENSIONS = new Set(["pdf", "png", "jpg", "jpeg"]);

/**
 * Either signal is enough. The declared type is missing on evidence rows and can be blank on an
 * upload from a browser that did not know it, so the extension stands in for it.
 */
export function isViewable(fileName: string | null | undefined, contentType?: string | null) {
  if (contentType && VIEWABLE_TYPES.has(contentType.toLowerCase())) {
    return true;
  }
  const dot = fileName?.lastIndexOf(".") ?? -1;
  if (!fileName || dot < 0) {
    return false;
  }
  return VIEWABLE_EXTENSIONS.has(fileName.slice(dot + 1).toLowerCase());
}
